module.exports = __webpack_public_path__ + "media/images/responsive/keywords/keyword_wayo-9121eb841a91e72107056c5590fba84d.jpg";